<script setup lang="ts">
  import { computed, getCurrentInstance } from 'vue';
  import PosUiBadge from '@/components/pos-v2/ui/PosUiBadge.vue';
  import { usePosMoney } from '@/composition/use-pos-money';
  import type { TReservationDepositStatus } from '@/interfaces/IReservation';
  const props = defineProps<{
    status: TReservationDepositStatus;
    amount?: number | null;
  }>();
  const money = usePosMoney();
  const proxy = getCurrentInstance()!.proxy;
  function i18nT(key: string, params?: Record<string, unknown>): string {
    return String(proxy.$t(key, params));
  }
  const label = computed(() => {
    if (props.status === 'none') return '';
    if (props.status === 'paid')
      return i18nT('reservations.deposit.paid', {
        amount: money.formatComputedMoney(props.amount ?? 0),
      });
    return i18nT(
      `reservations.deposit.${
        props.status === 'refund_failed' ? 'refundFailed' : props.status
      }`
    );
  });
  const color = computed(() =>
    props.status === 'paid' || props.status === 'applied'
      ? 'success'
      : props.status === 'refund_failed'
      ? 'error'
      : props.status === 'pending'
      ? 'warning'
      : 'neutral'
  );
</script>

<template>
  <PosUiBadge
    v-if="status !== 'none'"
    :color="color"
    size="xs"
    icon="cash-check"
    :label="label"
  />
</template>
